<template>
	<v-container fluid h-100 py-1 px-3>
		<v-layout row wrap fill-height align-content-space-between py-0>
			<v-flex xs12 class="audio-ai-panel__work-area pr-2">
				<v-textarea
					v-model="block.data.plainText"
					label="Write or paste your text"
					outlined
					rows="8"
					:counter="maxTextLength"
					:rules="[isTextValid]"
					class="pt-0 mt-0"
				/>

				<v-select
					v-if="!loadingVoices"
					v-model="block.data.voiceId"
					:items="voices"
					item-text="name"
					item-value="id"
					label="Select a voice"
					outlined
					dense
				/>
				<v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
			</v-flex>

			<v-flex xs12 class="text-xs-center audio-ai-panel__footer">
				<v-btn color="primary" @click="handleGenerateAudio" :disabled="!canGenerateAudio">Generate</v-btn>

				<BerthaDisclaimer class="mt-2"></BerthaDisclaimer>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { PFile } from 'plant-common/src/models/pFile';
import BerthaDisclaimer from '../_components/placeholders/BerthaDisclaimer.vue';

export default {
	components: {
		BerthaDisclaimer
	},
	props: ['block', 'isAIWorking'],
	inject: ['aiService', 'lessonPlanController'],
	data() {
		return {
			voices: [],
			maxTextLength: 9000,
			loadingVoices: false
		};
	},
	async created() {
		await this.getVoices();
	},
	computed: {
		canGenerateAudio() {
			return this.isTextValid(this.block.data.plainText) === true && this.block.data.voiceId;
		}
	},
	methods: {
		isTextValid(text) {
			const isEmpty = text.trim() === '';
			if (isEmpty) return 'Text must not be empty';

			const isWithinRange = text.length < this.maxTextLength;
			if (!isWithinRange) return `Text exceeds ${this.maxTextLength} chars`;

			return true;
		},
		async getVoices() {
			try {
				this.loadingVoices = true;
				this.voices = await this.aiService.getAudioVoices();
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.loadingVoices = false;
			}
		},
		async generateAudio() {
			const result = await this.aiService.generateAudioFrom(this.block.data.plainText, this.block.data.voiceId);

			return result;
		},
		getFilenameFrom(url) {
			return url.split('/').pop();
		},
		async downloadFileFromUrl(url, filename = 'voice.mp3') {
			const fileData = await this.aiService.getFileBy(url);

			const blob = new Blob([new Uint8Array(fileData.data)], { type: 'audio/mpeg' });

			const file = new File([blob], filename, { type: blob.type });

			return file;
		},
		async handleGenerateAudio() {
			try {
				this.$emit('update:isAIWorking', true);

				const result = await this.generateAudio();

				const file = await this.downloadFileFromUrl(result.audioUrl, this.getFilenameFrom(result.audioUrl));
				const newFile = new PFile(file);
				await newFile.upload();

				this.block.data.audio = newFile;
				this.block.data.jobId = result.jobId;
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.$emit('update:isAIWorking', false);
			}
		}
	}
};
</script>
<style scoped>
.audio-ai-panel__work-area {
	max-height: 70%;
	overflow-y: scroll;
}
.audio-ai-panel__footer {
	position: sticky;
	bottom: 0;
}
</style>